export default __webpack_public_path__ + "static/media/job_portal_symbol.4a5cdf5b.svg";